import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { appUpdatePollStart } from '@perpay-web/fintech/actions/appUpdate';
import { appReady } from '@perpay-web/fintech/actions/router';
import App from '@perpay-web/fintech/components/screens/App/App';

const AppContainer = () => {
    const dispatch = useDispatch();

    const onMount = useCallback(() => {
        if (window.WEBPACK_DEV_SERVER) {
            return;
        }
        dispatch(appReady());
        dispatch(appUpdatePollStart());
    }, [dispatch]);

    return <App onMount={onMount} />;
};

export default AppContainer;
